/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit, LOCALE_ID } from '@angular/core';
 import { GoogleAnalyticsService } from './@core/utils/analytics.service';
//import { SeoService } from './@core/utils/seo.service';
import {TranslateService} from '@ngx-translate/core';
import { catchError } from 'rxjs/operators';


import { of } from 'rxjs';



const DEFAULT_LANGUAGE = "UA"
const LANGUAGES = [
  //'UA'
]



@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
 //, private seoService: SeoService
  constructor( private analytics: GoogleAnalyticsService, translate: TranslateService) {
  
    let lang =  this.getLanguage()

    if(LANGUAGES.includes(lang.toUpperCase())){
      translate.use(lang.toLowerCase()).pipe(catchError((er:any)=>{
        translate.setDefaultLang(DEFAULT_LANGUAGE.toLocaleLowerCase());
        return of('Language not loaded')
      })).subscribe((r:any)=>{})

    } else {
      translate.setDefaultLang(DEFAULT_LANGUAGE.toLocaleLowerCase());
    }
  }


  getLanguage(){

    let localStorageLenguage = localStorage.getItem('language')

    if(localStorageLenguage?.length === 2){
      return localStorageLenguage
    }


    var userLang =  navigator?.language  || 'xx'; 

    //console.log(userLang)
    if(userLang){
      userLang = (userLang.split('-')[0]).toLocaleLowerCase()
    }
    return userLang === 'ru' ? 'ua' : userLang


  }



  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.analytics.emitCurrentPageView();

    // this.seoService.trackCanonicalChanges();
  }
}
